import styled from 'styled-components';

export const Container = styled.a`
  display: flex;
  flex-direction: row;
  padding: 16px;
  cursor: pointer;
  text-decoration: none;
`;

export const Text = styled.p`
  color: #fff;
`;

Text.xs = styled.p`
  height: 20px;
  font-size: 12.8px;
  color: #fff;
`;

export const Icon = styled.img`
  height: 24px;
  margin-right: 12px;
`;

Icon.xs = styled.img`
  height: 20px;
  margin-right: 12px;
`;
